module.exports = __webpack_public_path__ + "img/icon_st04.8446a5b2.png";